"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const react_select_1 = __importDefault(require("react-select"));
const ControlledAppSelect = ({ label, className, control, name, options, defaultValue, afterChangeAction, }) => {
    const selectValue = (value, options) => {
        const option = options.find((item) => item.value == value) || options[0];
        return option === null || option === void 0 ? void 0 : option.label;
    };
    return ((0, jsx_runtime_1.jsxs)(react_bootstrap_1.FormGroup, Object.assign({ className: className }, { children: [label && (0, jsx_runtime_1.jsx)(react_bootstrap_1.FormLabel, { children: label }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, render: ({ field: { onChange, value } }) => ((0, jsx_runtime_1.jsx)(react_select_1.default, { options: options, value: {
                        value: value,
                        label: selectValue(value, options),
                    }, onChange: (e) => {
                        onChange(e.value);
                        if (afterChangeAction) {
                            afterChangeAction();
                        }
                    }, defaultValue: options.find((item) => item.value == defaultValue), classNames: {
                        control: (state) => `form-select-themed ${state.isFocused ? "form-select-themed_focused" : ""}`,
                        valueContainer: () => "form-select-container-themed",
                        menu: () => "form-select-themed-menu",
                        menuList: () => "form-select-themed-menu",
                        option: (state) => `form-select-themed-menu-option ${state.isSelected ? "form-select-themed-menu-option_selected" : ""} ${state.isFocused ? "form-select-themed-menu-option_focused" : ""}`,
                        input: () => "form-select-themed-input",
                        dropdownIndicator: () => "form-select-themed-indicator",
                        singleValue: () => "form-select-themed-singleValue",
                    } })) })] })));
};
exports.default = ControlledAppSelect;
